import React from 'react'
import { Trans } from 'react-i18next'

interface Props {
  className?: string
}

const DisclaimerRecaptcha = ({ className = '' }: Props) => {
  return (
    <p className={className}>
      <Trans ns='strRegister' i18nKey='recaptchaDisclaimer'>
        This site is protected by reCAPTCHA and the Google{' '}
        <a href='https://policies.google.com/privacy' target='_blank' rel='noopener noreferrer'>
          Privacy Policy
        </a>{' '}
        and{' '}
        <a href='https://policies.google.com/terms' target='_blank' rel='noopener noreferrer'>
          Terms of Service
        </a>{' '}
        apply.
      </Trans>
    </p>
  )
}

export default DisclaimerRecaptcha
